import { IPaging } from "../models/isearch-response";

const paginationContainer: HTMLElement = document.querySelector("#search-pagination");
const paginationProtoType: HTMLElement = document.querySelector(".prototype__pagination");
const paginationItemProtoType: HTMLElement = document.querySelector(".prototype__pagination__item");

export const UpdatePagination = (pagination: IPaging): void => {
    paginationContainer.innerHTML = "";
	if (!pagination.pageLinks || pagination.pageLinks.length === 0) {
        return;
    }

    const paginationElement = paginationProtoType.cloneNode(true) as HTMLElement;
    paginationElement.classList.remove("prototype__pagination");

    UpdatePrevButton(paginationElement, pagination);
    UpdateNextButton(paginationElement, pagination);
	UpdatePageLinks(paginationElement, pagination);

    paginationContainer.append(paginationElement);

};

function UpdatePageLinks(paginationElement: HTMLElement, pagination: IPaging): void {
	const paginationList = paginationElement.querySelector(".pagination")

	if (pagination.pageLinks.length > 0 && pagination.pageLinks[0].number > pagination.firstLink.number) {
		const listItem = paginationItemProtoType.cloneNode(true) as HTMLElement;
		listItem.innerHTML = "..."
		paginationList.append(listItem);
	}

	pagination.pageLinks.forEach(function (pageLink) {
		const listItem = paginationItemProtoType.cloneNode(true) as HTMLElement;
		const listLink = listItem.querySelector("a") as HTMLAnchorElement;
		listLink.innerHTML = `${pageLink.number}`;
		listLink.setAttribute("data-url", pageLink.searchParams);
		let fullUrlCrawler = "";
		if (pageLink.number !== 1) {
			fullUrlCrawler = `${window.location.origin}${window.location.pathname}?filter=${window.btoa(pageLink.searchParams)}`;
		} else {
			fullUrlCrawler = `${window.location.origin}${window.location.pathname}`;
		}
         
		listLink.href = fullUrlCrawler;
		if (pagination.currentPage === pageLink.number) {
            listLink.classList.add("active");
		}
        paginationList.append(listItem);
    })

	if (pagination.pageLinks.length > 0 && pagination.pageLinks[pagination.pageLinks.length - 1].number > pagination.lastLink.number) {
        const listItem = paginationItemProtoType.cloneNode(true) as HTMLElement;
        listItem.innerHTML = "..."
        paginationList.append(listItem);
    }
}

function UpdateNextButton(paginationElement: HTMLElement, pagination: IPaging): void {
	const nextButton = paginationElement.querySelector(".pagination__btn.next") as HTMLAnchorElement;
	if (!pagination.nextLink?.searchParams) {
        nextButton.remove();
    }
	else {
		const fullUrlCrawler = `${window.location.origin}${window.location.pathname}?filter=${window.btoa(pagination.nextLink.searchParams)}`;
		nextButton.setAttribute("data-url", pagination.nextLink.searchParams);
		nextButton.href = fullUrlCrawler;
    }
}

function UpdatePrevButton(paginationElement: HTMLElement, pagination: IPaging): void {
	const prevButton = paginationElement.querySelector(".pagination__btn.prev") as HTMLAnchorElement;
	if (!pagination.previousLink?.searchParams) {
        prevButton.remove();
    }
	else {
		const fullUrlCrawler = `${window.location.origin}${window.location.pathname}?filter=${window.btoa(pagination.previousLink.searchParams)}`;
		prevButton.setAttribute("data-url", pagination.previousLink.searchParams);
		prevButton.href = fullUrlCrawler;
    }
}
